@if (registerUser()) {
<div class="carousel-loader">
  <!-- Animación Lottie del autobús -->
  <div class="carousel-loader__bus-section">
    <ng-lottie class="carousel-loader__bus-animation" [options]="busAnimationOptions" />
  </div>

  <!-- Logos de patrocinadores -->
  <div class="carousel-loader__sponsors">
    <div class="carousel-loader__sponsor-item carousel-loader__sponsor-item--emt">
      <img src="assets/imgs/logo-emt.png" alt="EMT Madrid" class="carousel-loader__sponsor-logo" />
    </div>
    <div class="carousel-loader__sponsor-divider">
      <span class="carousel-loader__sponsor-divider-line"></span>
    </div>
    <div class="carousel-loader__sponsor-item carousel-loader__sponsor-item--smart">
      <img src="assets/imgs/logo-smart-tourism.png" alt="Smart Tourism" class="carousel-loader__sponsor-logo" />
    </div>
  </div>

  <!-- Texto de carga -->
  <app-loader-carouse-text />
</div>
}